export default __webpack_public_path__ + "static/insta-hotels-14-084c62fe9b733d633273740b6279fd85.jpg";